import styled from "styled-components";

export const PageWrapper = styled.div`
  @media not print {
    display: flex;
    align-items: stretch;
    height: 100%;
    width: 100%;
    position: absolute;
    flex-direction: column;
  }

  @media print {
    overflow: visible;
    height: auto;
    position: relative;
  }

  h1,
  h2,
  h3,
  h4,
  p {
    font-family: "Open Sans Condensed" !important;
  }
`;

export const EmptyStateWrapper = styled.div`
  h1,
  h2,
  h3,
  h4,
  p {
    font-family: Roboto, "Helvetica Neue", Arial, Helvetica, sans-serif !important;
  }
`;

export const PageContent = styled.div`
  flex-grow: 1;
  position: relative;
  background: #f3f3f3;
  overflow: auto;

  @media print {
    background: #fff;
    overflow: visible;
  }
`;

export const SidebarWrapper = styled.div`
  @media not print {
    display: flex;
    align-items: stretch;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    position: absolute;
  }

  @media print {
    position: static;
  }

  @media not print {
    .fill {
      height: 100%;
      width: 0.01%;
      flex-grow: 1;
      position: relative;
      display: flex;
      justify-content: center;
    }
  }

  #divToPrint {
    padding-top: 25px;
    overflow-y: auto;
    overflow-x: visible;
    width: ${(props) => (props.landscape ? `1113` : `870`)}px;

    @media print {
      padding-top: 0;
      width: inherit;
    }
  }
`;

export const DimmerStyle = styled.div`
  &.ui.dimmer {
    position: fixed !important;
    top: 61px !important;
    height: calc(100% - 61px);

    visibility: visible;
    opacity: 1;
    transition: visibility 0.01s 0.1s, opacity 0.01s 0.1s linear;

    &.hide {
      visibility: hidden !important;
      opacity: 0;
      transition: visibility 0.2s 0.5s, opacity 0.2s 0.5s linear;
    }

    .bar {
      transition: width 0.5s ease, background-color 0.5s ease;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/style.js